// Template199: Bangkok - Chatuchak (Día 4). Idéntico a PageChatuchak.jsx. borderRadius: "12px".

import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import { useMapFullscreen } from "../../context/MapFullscreenContext";

const Template199 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;
	const [mapLoaded, setMapLoaded] = useState(false);
	const [fullscreen, setFullscreen] = useState(false);
	const { setMapFullscreen } = useMapFullscreen() || {};

	const headerText = page?.texts?.[0]?.content ?? "Día 4: Mercados";
	const tipText = page?.texts?.[1]?.content;
	const chatuchakTitle = page?.texts?.[2]?.content;
	const chatuchakBody = page?.texts?.[3]?.content;
	const masajeText = page?.texts?.[4]?.content;
	const mapEmbedUrl = page?.data?.mapEmbedUrl;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const chatuchakImage = getImageSrc("chatuchak");
	const stickerUrl = getCanvasImageUrl("sticker");
	const masajeStickerUrl = getCanvasImageUrl("masaje-sticker");
	const logoImage = getCanvasImageUrl("logo");
	const actualHeaderColor = headerBackgroundColor || "#E8A838";

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "13px",
		color: "#444",
		margin: 0,
	};

	useEffect(() => {
		const style = document.createElement("style");
		style.innerHTML = `@keyframes template199-spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`;
		document.head.appendChild(style);
		return () => document.head.removeChild(style);
	}, []);

	useEffect(() => {
		if (typeof setMapFullscreen === "function") {
			setMapFullscreen(fullscreen);
			return () => setMapFullscreen(false);
		}
	}, [fullscreen, setMapFullscreen]);

	if (fullscreen && mapEmbedUrl) {
		return (
			<Box
				sx={{
					position: "fixed",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					backgroundColor: "#fff",
					zIndex: 9999,
					display: "flex",
					flexDirection: "column",
				}}
			>
				<Box
					sx={{
						padding: "10px",
						textAlign: "right",
						backgroundColor: "#e8a838",
					}}
				>
					<Box
						component="button"
						onClick={() => setFullscreen(false)}
						sx={{
							backgroundColor: "#fff",
							color: "#e8a838",
							border: "none",
							borderRadius: "8px",
							padding: "6px 12px",
							fontWeight: 600,
							cursor: "pointer",
						}}
					>
						← Volver a la guía
					</Box>
				</Box>
				<Box
					component="iframe"
					title="Mapa grande"
					src={mapEmbedUrl}
					width="100%"
					sx={{ border: 0, flex: 1 }}
					allowFullScreen
					loading="lazy"
				/>
			</Box>
		);
	}

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				height: "100%",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt=""
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			{/* Área del mapa: igual que PageChatuchak — contenedor con flex:1 y dentro un wrapper flex:1 con el iframe al 100% */}
			<Box
				data-block-id="map"
				sx={{
					display: "flex",
					flexDirection: "column",
					flex: 1,
					height: "100%",
					backgroundColor: "#f7f7f7",
					position: "relative",
					marginTop: "-70px",
					minHeight: 400,
				}}
			>
				{mapEmbedUrl && !mapLoaded && (
					<Box
						sx={{
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							position: "absolute",
							top: 0,
							left: 0,
							right: 0,
							bottom: 0,
							zIndex: 1,
						}}
					>
						<Box
							sx={{
								width: 20,
								height: 20,
								border: "4px solid #ccc",
								borderTop: "4px solid #24221a",
								borderRadius: "50%",
								animation: "template199-spin 1s linear infinite",
							}}
						/>
					</Box>
				)}
				{mapEmbedUrl && (
					<Box
						component="button"
						onClick={() => setFullscreen(true)}
						sx={{
							position: "absolute",
							top: 80,
							right: 10,
							backgroundColor: "#e8a838",
							color: "#fff",
							padding: "8px 10px",
							fontSize: "11px",
							borderRadius: "8px",
							boxShadow: "1px 1px 2px rgba(0,0,0,0.2)",
							zIndex: 4,
							border: "none",
							cursor: "pointer",
						}}
					>
						Ver mapa grande
					</Box>
				)}
				{mapEmbedUrl ? (
					<Box
						component="iframe"
						title="Mapa"
						src={mapEmbedUrl}
						loading="lazy"
						sx={{
							border: 0,
							width: "100%",
							height: "100%",
							display: "block",
						}}
						onLoad={() => setMapLoaded(true)}
					/>
				) : (
					chatuchakImage && (
						<Box
							component="img"
							src={chatuchakImage}
							alt=""
							sx={{ width: "100%", height: "100%", objectFit: "cover" }}
						/>
					)
				)}

				{/* Sticker al lado del mapa: en PageChatuchak es la misma imagen chatuchak (ChatuchakImg), no el sticker separado */}
				{(chatuchakImage || stickerUrl) && (
					<Box
						component="img"
						src={chatuchakImage || stickerUrl}
						alt=""
						sx={{ width: 120, position: "absolute", bottom: -20, left: -20 }}
					/>
				)}
				{tipText && (
					<Box
						sx={{
							position: "absolute",
							bottom: isSmallScreen ? 80 : 60,
							left: isSmallScreen ? 6 : 40,
							backgroundColor: "#fff8db",
							border: "2px solid #f5c400",
							borderRadius: "16px 16px 16px 0px",
							padding: "10px 12px",
							fontSize: 11,
							color: "#444",
							boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
							maxWidth: 120,
						}}
					>
						{tipText}
					</Box>
				)}
			</Box>

			<Box data-block-id="text-1" sx={{ padding: "10px 12px", position: "relative" }}>
				<Box
					data-block-id="text-2"
					sx={{
						backgroundColor: "#FFF3CD",
						border: "3px solid #E8A838",
						borderRadius: "12px",
						padding: "12px 12px",
						fontSize: "12px",
						color: "#333",
						width: "100%",
						marginBottom: 1.5,
					}}
				>
					<Box
						component="h4"
						sx={{
							margin: 0,
							marginBottom: 1,
							fontSize: "13px",
							fontWeight: 700,
							color: "#E8A838",
							textTransform: "uppercase",
						}}
					>
						{chatuchakTitle}
					</Box>
					{chatuchakBody && (
						<Box component="p" sx={estiloP}>
							{chatuchakBody}
						</Box>
					)}
				</Box>
				<Box
					data-block-id="text-3"
					sx={{
						width: "100%",
						position: "relative",
						backgroundColor: "#fff8db",
					}}
				>
					{masajeText && (
						<Box
							component="p"
							sx={{
								...estiloP,
								padding: 1.5,
								borderRadius: "12px",
								width: "80%",
							}}
						>
							{masajeText}
						</Box>
					)}
					{masajeStickerUrl && (
						<Box
							component="img"
							src={masajeStickerUrl}
							alt=""
							sx={{ width: 100, position: "absolute", bottom: 0, right: -20 }}
						/>
					)}
				</Box>
			</Box>
		</Box>
	);
};

Template199.thumbnail = "/images/template-1.png";
export default Template199;
